import { SalesChannelCategoryMappingCreatePage } from "@/features/sales-channel-category-mapping/pages/SalesChannelCategoryMappingCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-mapping/create",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				// Needs the taxonomy read scope too — the form's GrabMart picker queries it.
			permissions: [
				"sales_channel_category_groups.create",
				"sales_channel_categories.view",
			],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryMappingCreatePage,
});
